import { brand } from "@/brandVariables/getBandVariables";

export const BrandLogo = () => {
  const Logo = brand.brandLogo;

  return (
    <>
      {brand.brandLogoType === "element" ? (
        <Logo width="220" />
      ) : (
        <img src={Logo} width={220} />
      )}
    </>
  );
};
